export function isIsoDate(str) {
  if (!/\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/.test(str))
    return false;
  const d = new Date(str);
  return !isNaN(d.getTime()) && d.toISOString().startsWith(str); // valid date
}
